export default __webpack_public_path__ + "static/media/scrollbar_increment.7831b876.svg";